import { useCallback, useEffect } from "react";

export enum KeyboardKeys {
	Escape = "Escape",
	ArrowLeft = "ArrowLeft",
	ArrowRight = "ArrowRight",
	Enter = "Enter",
}

export const useKeyboardKeyPressed = (instructions: Record<Partial<string>, () => void>): void => {
	const handleKeyPressed = useCallback(
		(event: KeyboardEvent) => {
			if (event.key in instructions) {
				instructions[event.key]();
				event.preventDefault();
			}
		},
		[instructions],
	);

	useEffect(() => {
		document.addEventListener("keydown", handleKeyPressed, false);

		return () => {
			document.removeEventListener("keydown", handleKeyPressed, false);
		};
	}, [handleKeyPressed]);
};
